const environments = {
  development: {
    apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:5000',
    apiGateway: false
  },
  staging: {
    apiUrl: process.env.REACT_APP_API_URL || 'https://api-staging.jamdungjobs.com',
    apiGateway: true
  },
  production: {
    apiUrl: process.env.REACT_APP_API_URL || 'https://api.jamdungjobs.com',
    apiGateway: true
  }
};

const environment = process.env.REACT_APP_ENV || 'development';

// Ensure apiUrl never ends with /api to avoid double prefixes
// But don't strip if /api IS the entire value (used as a relative path in production)
const stripTrailingApi = (url) => {
  if (url === '/api') return url;
  return url.endsWith('/api') ? url.replace(/\/api$/, '') : url;
};
environments.development.apiUrl = stripTrailingApi(environments.development.apiUrl);
environments.staging.apiUrl = stripTrailingApi(environments.staging.apiUrl);
environments.production.apiUrl = stripTrailingApi(environments.production.apiUrl);

export const config = {
  ...environments[environment],
  storageKeys: {
    authToken: 'jamdung_auth_token'
  }
};

// Helper function to build API URLs
export const buildApiUrl = (path) => {
  // Remove any leading slashes from path
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${config.apiUrl}/${cleanPath}`;
};

// Helper function to build asset URLs (like logos)
export const buildAssetUrl = (path) => {
  if (!path) return '';
  
  // If the path already contains 'uploads/', don't modify it
  if (path.includes('uploads/')) {
    return path;
  }
  
  // Otherwise, ensure path starts with uploads/
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `/api/uploads/${cleanPath}`;
};
